<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-10-21 17:10:41
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-02 14:54:14
 * @FilePath: \seller.sviptrader.com\src\components\business\applySampleDrawer\components\errorDialog\batchHintDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog title="提示" :visible.sync="dialogVisible" :width="dialogWidth" :append-to-body="true" :before-close="handleClose">
		<div class="content">
			<template v-if="isNext">
				<div class="flex-row font-h4-regular">
					<i class="el-icon-warning mt-4"></i>
					<div class="text">{{ desc2Obj.label1 }}</div>
				</div>
				<div class="yx-color-text-primary font-h4-regular ml-20">{{ desc2Obj.label2 }}</div>
			</template>
			<div class="flex-row" v-else>
				<i class="el-icon-warning mt-4"></i>
				<div class="text">{{ desc1 }}</div>
			</div>
			<template v-if="checkType === 4">
				<el-table class="mt-16" :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
					<el-table-column label="达人商务" width="200">
						<template v-slot="{ row }">
							<span>{{ row.partner_role_name }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="" label="合作达人">
						<template v-slot="{ row }">
							<div class="flex-row flex-align-center">
								<YxAvatar :src="row.head" :size="24" />
								<div class="ml-4">
									<div class="yx-color-text-primary">{{ row.anchor_name }}</div>
									<el-tag size="mini" :type="tagData.style">{{ tagData.typeName }}</el-tag>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</template>
			<template v-else>
				<el-table class="mt-16" :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
					<el-table-column label="商品信息" width="260">
						<template v-slot="{ row }">
							<div class="product">
								<el-image :src="row.product_pic" />
								<div class="ml-8">
									<div class="flex-row-align-center">
										<platform-icon :platformId="row.platformId"></platform-icon>
										<el-tooltip placement="top" :content="row.product_name" v-ak-tooltip-auto-show>
											<span class="ml-4 line-ellipsis-1 yx-color-text-primary" style="width: 100%">{{ row.product_name }}</span>
										</el-tooltip>
									</div>
									<div class="font-h6-regular yx-color-text-regular">商品ID: {{ row.third_product_id }}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="达人商务" width="110">
						<template v-slot="{ row }">
							<el-tooltip placement="top" :content="row.partner_role_name" v-ak-tooltip-auto-show>
								<span class="line-ellipsis-1 yx-color-text-primary" style="width: 100%">{{ row.partner_role_name }}</span>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column label="合作团长" width="100" v-if="tagData.typeName === '团长分销'">
						<template v-slot="{ row }">
							<el-tooltip placement="top" :content="row.institution_name" v-ak-tooltip-auto-show>
								<span class="line-ellipsis-1 yx-color-text-primary" style="width: 100%">{{ row.institution_name }}</span>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="" label="合作达人" width="130">
						<template v-slot="{ row }">
							<div class="flex-row flex-align-center">
								<div>
									<YxAvatar :src="row.head" :size="24" />
								</div>
								<div class="ml-4">
									<el-tooltip v-if="checkType === 5" placement="top" :content="row.anchor_name || '无关联达人'" v-ak-tooltip-auto-show>
										<span class="line-ellipsis-1 yx-color-text-primary" style="width: 100%">{{ row.anchor_name || '无关联达人' }}</span>
									</el-tooltip>
									<el-tooltip v-else placement="top" :content="row.anchor_name" v-ak-tooltip-auto-show>
										<span class="line-ellipsis-1 yx-color-text-primary" style="width: 100%">{{ row.anchor_name }}</span>
									</el-tooltip>
									<el-tag size="mini" :type="tagData.style">{{ tagData.typeName }}</el-tag>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="最近申样时间">
						<template v-slot="{ row }">
							<span>{{ row.apply_status_time | formatDateTime }}</span>
						</template>
					</el-table-column>
				</el-table>
			</template>
		</div>
		<span slot="footer" v-if="isNext">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="confirm">确认合作</el-button>
		</span>
		<span slot="footer" v-else>
			<el-button type="primary" @click="handleClose">我知道了</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'batchHintDialog',
	components: {
		
	},
	computed: {
		...mapState(['vuex_userId']),
		tagData({ retailType, checkType }) {
			const obj = {
				0: {},
				1: {
					style: retailType ? 'primary' : 'danger',
					typeName: retailType ? '团长分销' : '达人分销',
				},
				2: {
					style: 'primary',
					typeName: '团长分销',
				},
				3: {
					style: 'danger',
					typeName: '达人分销',
				},
				4: {
					style: 'primary',
					typeName: '团长分销',
				},
				5: {
					style: 'primary',
					typeName: '团长分销',
				},
			};
			return obj[checkType];
		},
		isNext({ checkType }) {
			const obj = {
				1: false,
				2: true,
				3: true,
				4: true,
				5: true,
			};
			return obj[checkType];
		},
		desc1({ retailType }) {
			const obj = {
				0: '以下商品正在与对应达人合作，当前合作结束后才能继续合作！',
				1: '以下商品正在与对应团长合作，当前合作进度结束后才能继续合作！',
			};
			return obj[retailType];
		},
		desc2Obj({ checkType, retailType, vuex_userId, list }) {
			//如果当前申样为团长申样,则提示以下信息
			if (retailType) {
				let meet = list.some(v => v.user_id !== vuex_userId);
				return meet
					? {
							label1: '其他商务正在与该团长合作该商品。在团队多对一按[团长]归属业绩时，若您继续寄样，业绩将无法归属，请确认是否继续?',
							label2: '',
					  }
					: {
							label1: '以下商品正在与对应团长进行合作，是否继续给该团长寄样?',
							label2: '',
					  };
			} else {
				const obj = {
					2: {
						label1: '确认是否继续合作？',
						label2: '以下商品正在与对应团长合作。',
					},
					3: {
						label1: '确认是否通过团长与达人继续合作？',
						label2: '以下商品正在与对应达人合作。',
					},
					4: {
						label1: '确认是否继续通过团长与达人继续合作？',
						label2: '以下达人存在团队达人CRM中且有商务正在跟进。',
					},
					5: {
						label1: '是否确认通过团长与该达人合作？',
						label2:
							'以下商品正在与对应团长/达人合作，在团队多对一按[团长]归属业绩时，若您继续寄样，业绩将无法归属（相同商务寄样可“补寄样品”），请确认是否继续?',
					},
				};
				return obj[checkType];
			}
		},
		dialogWidth({ checkType }) {
			return checkType == 4 ? '600px' : '800px';
		},
	},
	data() {
		return {
			list: [],
			dialogVisible: false,
			checkType: 0,
			retailType: 0,
		};
	},
	methods: {
		show(list, type, retailType) {
			this.retailType = retailType;
			this.checkType = type;
			this.list = list;
			this.dialogVisible = true;
		},
		handleClose() {
			this.list = [];
			this.checkType = 0;
			this.retailType = 0;
			this.$emit('reset');
			this.dialogVisible = false;
		},
		confirm() {
			this.$emit('sampleOrderBatchApply', false);
			this.handleClose();
		},
	},
};
</script>

<style lang="less" scoped>
.content {
	padding: 8px;
	.el-icon-warning {
		color: rgb(250, 143, 20);
		font-size: 16px;
	}
	.text {
		color: #1d2129;
		font-size: 14px;
		line-height: 24px;
		margin-left: 6px;
	}
	.product {
		display: flex;
		.el-image {
			width: 40px;
			height: 40px;
			flex-shrink: 0;
		}
	}
}
/deep/.table-row .el-table__cell:not([rowspan='1']) {
	border-right: 1px solid #f0f1f5;
}
</style>
